import { CategoryRepository } from "../../../../data/repository/category/CategoryRepository";
import { QuestionRepository } from "../../../../data/repository/question/QuestionRepository";
import { Message } from "../../../model/Auth";
import { Category } from "../../../model/Category";
import { Question } from "../../../model/Question";
import { ResponseState, State } from "../../../model/ResponseState";

export interface UpdateQuestionUseCase {
  invoke: (question: Question) => Promise<ResponseState<Message>>;
}

export class UpdateQuestionUseCaseImpl implements UpdateQuestionUseCase {
  private questionRepository: QuestionRepository;

  constructor(questionRepository: QuestionRepository) {
    this.questionRepository = questionRepository;
  }

  async invoke(question: Question): Promise<ResponseState<Message>> {
    try {
      let response = await this.questionRepository.updateQuestion(question);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
